export default __webpack_public_path__ + "static/media/userprofile.e39246c2.svg";